'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bem = require('../lib/bem');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TabLabel = function (_PureComponent) {
    _inherits(TabLabel, _PureComponent);

    function TabLabel(props, context) {
        _classCallCheck(this, TabLabel);

        var _this = _possibleConstructorReturn(this, (TabLabel.__proto__ || Object.getPrototypeOf(TabLabel)).call(this, props, context));

        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }

    _createClass(TabLabel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.context.bem.subscribe(this);
            this.context.tabbordionPanel.subscribe(this);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.context.bem.unsubscribe(this);
            this.context.tabbordionPanel.unsubscribe(this);
        }
    }, {
        key: 'onClick',
        value: function onClick(event) {
            if (event.defaultPrevented) {
                return;
            }

            var onClickLabel = this.context.tabbordionPanel.onClickLabel;

            if (onClickLabel) {
                event.preventDefault();
                onClickLabel();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$bem$getState = this.context.bem.getState(),
                bemSeparator = _context$bem$getState.bemSeparator,
                blockElements = _context$bem$getState.blockElements;

            var _context$tabbordionPa = this.context.tabbordionPanel.getState(),
                inputId = _context$tabbordionPa.inputId,
                modifiers = _context$tabbordionPa.modifiers;

            var _props = this.props,
                className = _props.className,
                Component = _props.component,
                props = _objectWithoutProperties(_props, ['className', 'component']);

            var panelBem = (0, _bem.bemClassName)(blockElements, 'label', modifiers, bemSeparator);

            return _react2.default.createElement(Component, _extends({
                className: !panelBem ? className : className ? panelBem + ' ' + className : panelBem,
                htmlFor: inputId,
                onClick: this.onClick
            }, props));
        }
    }]);

    return TabLabel;
}(_react.PureComponent);

TabLabel.contextTypes = {
    bem: _propTypes2.default.object,
    tabbordionPanel: _propTypes2.default.object
};

TabLabel.defaultProps = {
    component: 'label'
};

TabLabel.propTypes = {
    className: _propTypes2.default.string,
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.string])
};

exports.default = TabLabel;


//////////////////
// WEBPACK FOOTER
// ./~/react-tabbordion/dist/module/components/TabLabel.js
// module id = 679
// module chunks = 0